import { cr } from "fire-wind-water";
import { Select } from "./select";

class Cascader extends Select {
  constructor(filed: unknown) {
    super(filed);
  }

  setValue(list: any[]): void {
    this.value = [];
    this.label = [];
    this.model = [];
    cr.each(list, (d) => {
      this.value.push(d.optionValue);
      this.label.push(d.optionId);
      this.model.push({ optionId: d.optionId, optionValue: d.optionValue });
    });
    this.dirty = true;
    this.isError();
  }

  initValue(o: any[]): void {
    this.value = [];
    this.label = [];
    this.model = [];
    let items = this.cascaderList;
    cr.each(o, (d) => {
      const x = items.filter((m) => {
        return m.optionId === d;
      })[0];
      if (x) {
        this.value.push(x.optionValue);
        this.label.push(x.optionId);
        this.model.push({ optionId: x.optionId, optionValue: x.optionValue });
        items = x.children || [];
      } else {
        items = [];
      }
    });
  }
}

export { Cascader };
